import { createContext } from 'react';

export interface WindowDimensionsContext {
  width: number;
  height: number;
  deviceWidth: number;
  deviceHeight: number;
}

export const WindowDimensionsContext = createContext<WindowDimensionsContext>({
  width: window.innerWidth,
  height: window.innerHeight,
  deviceWidth: window.screen.width,
  deviceHeight: window.screen.height,
});
